module.exports = __webpack_public_path__ + "img/荣誉证书07_高新技术企业证书.c7230ca2.png";